import { customEvent } from "goi_common";
import { ArrowRightIcon } from "@/components/DirectionsIcons";
import type {
  MubinsoStep,
  MubinsoTemplate,
} from "@/utils/buildMubinsoPageProps";

interface MubinsoProcessProps {
  parlorId: number;
  steps: MubinsoStep[];
  ctaHref: string;
  title?: string;
  /** B 는 중간 CTA 와 2일장 안내 문단을 뺀다. 2일장 안내는 B 에서 안치료 FAQ 가 대신한다 */
  variant?: MubinsoTemplate;
}

export const MubinsoProcess = ({
  parlorId,
  steps,
  ctaHref,
  title = "무빈소 장례, 진행 절차 안내",
  variant = "A",
}: MubinsoProcessProps) => {
  const isB = variant === "B";
  return (
    <section className="mb-process" aria-labelledby="mb-process-title">
      <h2 id="mb-process-title" className="mb-process__title">
        {title}
      </h2>

      <ol className="mb-process__steps">
        {steps.map((step) => (
          <li key={step.day} className="mb-step">
            <span className="mb-step__day">{step.day}</span>
            <div className="mb-step__body">
              <h3 className="mb-step__name">{step.name}</h3>
              <p className="mb-step__desc">{step.desc}</p>
            </div>
          </li>
        ))}
      </ol>

      {!isB && (
        <p className="mb-process__note">
          법령상 사망 후 24시간 이내에는 화장할 수 없어, 무빈소도 보통 2일장으로
          진행됩니다. 화장장 예약 상황에 따라 3일장으로 길어질 수 있습니다.
        </p>
      )}

      {!isB && (
        <a
          className="mb-cta mb-cta--light"
          href={ctaHref}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_mubinso",
                trigger_and_target: "btn_cta_process",
                properties: { parlor_id: parlorId },
              },
            })
          }
        >
          무빈소 장례 절차 자세히 보기
          <ArrowRightIcon size={16} />
        </a>
      )}
    </section>
  );
};
